import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function OnboardingBodyStages() {
    return (
        <OnboardingBody title='What are stages?'>
            <div>
                <p>
                    Stages describe the major milestones of a lead within a pipeline, from
                    acquisition to closing.
                </p>
                <p>
                    A well-designed stage should have clearly defined goals, including specific
                    criteria to move a lead to the next stage.
                </p>
                <p>
                    Define confidence levels at each stage, so that leads update your forecasts as
                    they progress.
                </p>
            </div>
        </OnboardingBody>
    );
}
